"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgo-priolo": {
    "7a7e65bc": [{
      "hkey": "ce5d2b41",
      "slug": "arpesina-casa-gallotti",
      "name": "Arpesina-Casa Gallotti",
      "primary": true,
      "skipSearch": false
    }],
    "arpesina": [{
      "hkey": "ce5d2b41",
      "slug": "arpesina-casa-gallotti",
      "name": "Arpesina-Casa Gallotti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f90d64c1": [{
      "hkey": "30c7418a",
      "slug": "cappelletta-olesi",
      "name": "Cappelletta-Olesi",
      "primary": true,
      "skipSearch": false
    }],
    "olesi": [{
      "hkey": "30c7418a",
      "slug": "cappelletta-olesi",
      "name": "Cappelletta-Olesi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0cc47e87": [{
      "hkey": "8fd98b26",
      "slug": "borgo-priolo",
      "name": "Borgo Priolo",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "8fd98b26",
      "slug": "borgo-priolo",
      "name": "Borgo Priolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42fcfa4c": [{
      "hkey": "8fd98b26",
      "slug": "borgo-priolo",
      "name": "Borgo Priolo",
      "primary": true,
      "skipSearch": false
    }],
    "santa-cristina-di-stefanago": [{
      "hkey": "8fd98b26",
      "slug": "borgo-priolo",
      "name": "Borgo Priolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cb6ffb7": [{
      "hkey": "8fd98b26",
      "slug": "borgo-priolo",
      "name": "Borgo Priolo",
      "primary": true,
      "skipSearch": false
    }],
    "torre-del-monte": [{
      "hkey": "8fd98b26",
      "slug": "borgo-priolo",
      "name": "Borgo Priolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;